import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'

const useRecertificationSlides = create(immer((set, get) => ({
    activeSlideIndex: 0,
    setActiveSlideIndex: (index) => set({ activeSlideIndex: index }),
    totalSlides: 0,
    setTotalSlides: (totalSlides) => set({ totalSlides }),

    allRequiredSlidesConfirmed: false,
    slides: [],
    setSlides: (slides) => set({ slides }),

    fbiFields: {
        fbiSearch: 0,
        fbiTraining: [],
        fbiExperience: "",
        fbiClient: "",
    },
    setFbiFields: (fields) => set(p => {
        p.fbiFields = { ...p.fbiFields, ...fields }
    }),
    setFbiField: (key, value) => set(p => {
        p.fbiFields[key] = value
    }),
    modifySlide: (index, newItems, runRequiredSlidesConfirmationCheck = false) => {
        set(p => {
            p.slides[index] = { ...p.slides[index], ...newItems }
            if (runRequiredSlidesConfirmationCheck) {
                const { slides } = p
                const requiredSlides = slides.filter(slide => slide.requiresConfirmation)
                const requiredSlidesConfirmed = requiredSlides.every(slide => slide.isCompleted)
                p.allRequiredSlidesConfirmed = requiredSlidesConfirmed
            }
        })
    },
    resetAllFields: () => {
        set(p => {
            p.fbiFields = {
                fbiSearch: 0,
                fbiTraining: [],
                fbiExperience: "",
                fbiClient: "",
            }
            p.slides = []
            p.totalSlides = 0
            p.activeSlideIndex = 0
            p.allRequiredSlidesConfirmed = false
        })
    }
})))

export default useRecertificationSlides